import React, { useRef } from 'react'
import { trans } from '../../../../_providers/Translation'
import Dropdown from '@/components/partials/Dropdown'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {
    const statusDropdownRef = useRef(null)

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleStatus = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('status_id', val)
        }

    }

    const handleClearFilters = () => {
        props.handleSearch('date_from', '')
        props.handleSearch('date_to', '')
        props.handleSearch('status_id', '')
        props.handleSearch('name', '')
        statusDropdownRef.current.reset()
    }

    return (
        <form className="filter-standard">
            <div className="col select-filter-col">
                <label>
                    {trans('filters.filterBy')}
                </label>
                <select onChange={handleSelectMobileFilter}>
                    <option value="1" selected>
                        {trans('filters.name')}
                    </option>
                    <option value="2">
                        {trans('filters.email')}
                    </option>
                    <option value="3">
                        {trans('filters.phone')}
                    </option>
                    <option value="4">
                        {trans('filters.address')}
                    </option>
                    <option value="5">
                        {trans('filters.active')}
                    </option>
                    <option value="6">
                        {trans('filters.superPartner')}
                    </option>
                </select>
            </div>

            <div className="col" data-id="1">

                <input
                    type="search"
                    name="name"
                    onKeyUp={(e) => props.handleSearch(e.target.name, e.target.value)}
                    onChange={(e) => props.handleSearch(e.target.name, e.target.value)}
                    value={props.filters.name}
                    placeholder={trans('labels.search')}
                />
            </div>
            <div className="col" data-id="2">

                <Dropdown
                    inputIdValue={Number(props.filters.status_id)}
                    url="partners/relationships/statuses"
                    renderText={data => {
                        return data.label
                    }}
                    onChange={data => {
                        handleStatus(data)
                    }}
                    ref={statusDropdownRef}
                />
            </div>
            <div className="col" data-id="3">
                <DateRange
                    startDate={props.filters.date_from}
                    endDate={props.filters.date_to}
                    onStartDateChange={(date) => {
                        props.handleSearch('date_from', date)
                    }} onEndDateChange={(date) => {
                        props.handleSearch('date_to', date)
                    }}
                />
            </div>
            <div className='col'>
                <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                    {trans('buttons.clearFilters')}
                </button>
            </div>

        </form>
    )
}

export default Filter